import { styled, css } from '@planne-software/uni/mui/material';

export const ProductContainer = styled('li')<{ $isCompleted: boolean; $isSelected: boolean }>`
  display: flex;
  flex-direction: column;

  border-radius: 1rem;
  border: 1px solid ${({ theme }) => theme.tokens.colors['border-color-neutral-strong']};
  cursor: pointer;
  width: 100%;
  max-width: 100%;
  overflow: hidden;

  background-color: ${(props) => {
    if (props['aria-disabled']) return props.theme.tokens.colors['fill-color-neutral-soft'];

    if (props.$isSelected || props.$isCompleted) {
      return props.theme.tokens.colors['fill-color-primary-softest'];
    }

    return '#fff';
  }};

  opacity: ${(props) => (props['aria-disabled'] ? 0.7 : 1)};
  pointer-events: ${(props) => (props['aria-disabled'] || props.$isCompleted || props.$isSelected ? 'none' : 'auto')};

  &:last-of-type {
    margin-bottom: 4px;
  }
`;

export const ImageContainer = styled('div')(
  ({ theme }) => css`
    width: 100%;
    height: 97px;
    overflow: hidden;

    border-start-end-radius: 1rem;
    border-start-start-radius: 1rem;

    border-bottom: 1px solid ${theme.tokens.colors['border-color-neutral-strong']};

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  `,
);

export const ProductContentArea = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.5rem;

  .MuiScopedCssBaseline-root {
    background: inherit;
  }
`;

export const ProductName = styled('p')(({ theme }) => ({
  ...theme.tokens.typography['text-md-semibold'],
  margin: 0,
  padding: 0,
  color: theme.tokens.colors['text-color-neutral-strongest'],
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  justifyContent: 'space-between',
}));

export const ProductSelectionInfo = styled('div')`
  display: flex;
  flex-direction: row;
  gap: 0.25rem;
  align-items: center;

  color: ${({ theme }) => theme.tokens.colors['text-color-neutral-strongest']};

  p,
  svg {
    color: inherit;
  }
`;

export const SelectionInfo = styled('p')(({ theme }) => ({
  ...theme.tokens.typography['text-sm-regular'],
  margin: 0,
  padding: 0,
  color: 'inherit',
}));

export const ProductNameWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  align-items: center;
  justify-content: space-between;
`;

export const TariffContainer = styled('p')(({ theme }) => ({
  ...theme.tokens.typography['text-sm-regular'],
  margin: 0,
  padding: 0,
  color: 'inherit',
  display: 'flex',
  alignItems: 'center',
  gap: '0.25rem',
}));

export const ProductProviderName = styled('p')(({ theme }) => ({
  ...theme.tokens.typography['text-sm-regular'],
  margin: 0,
  padding: 0,
  marginTop: '-0.25rem',
  color: theme.tokens.colors['text-color-neutral-strongest'],
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
}));
